<template>
	<div v-if="isVisible" class="popup-container">
		<div class="card white popup">
			<h2>{{ title }}</h2>
			<div v-if="hasOptions" class="form-control">
				<label for="type">Sélectionner un type*</label>
				<select name="type" id="type" v-model="selectedType">
					<option v-for="type in flattenedTypes" :key="type.ID" :value="type.name">{{ type.name }}</option>
					<option value="autre">Autre</option>
				</select>
			</div>
			<div v-else class="form-control">
				<label for="customType">Entrez un nom</label>
				<input type="text" id="customType" v-model="customType" placeholder="Entrez un nom" v-alpha-numeric />
			</div>

			<div v-if="hasOptions && isCustomTypeSelected" class="form-control">
				<label for="customType">Entrez un nom</label>
				<input type="text" id="customType" v-model="customType" placeholder="Entrez un nom" v-alpha-numeric />
			</div>

			<div class="form-control">
				<label for="files" class="button outline orange dotted">Ajouter des fichiers</label>
				<input type="file" id="files" name="files" multiple @change="handleFileUpload" />
			</div>

			<div class="uploaded-files">
				<div v-for="file in uploadedFiles" :key="file.name" class="file-entry">
					<i v-if="file.name.toLowerCase().endsWith('.pdf')" class="bi bi-file-pdf-fill"></i>
					<i v-else class="bi bi-file-image-fill"></i>
					<p class="file-name" @click="openPreview(file)">{{ file.name }}</p>
					<p class="file-action" @click="openPreview(file)">Voir</p>
					<p>|</p>
					<p class="file-action" @click="deleteFile(file)">Supprimer</p>
				</div>
			</div>

			<p v-if="errorMessage">{{ errorMessage }}</p>
			<div class="popup-actions">
				<button class="button fill orange" @click="confirmAction">Confirmer</button>
				<button class="button outline orange" @click="cancelAction">{{ cancelButtonText }}</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "FichierSelectPopup",
	props: {
		isVisible: Boolean,
		title: String,
		confirmButtonText: {
			type: String,
			default: "Confirmer",
		},
		cancelButtonText: {
			type: String,
			default: "Annuler",
		},
	},
	data() {
		return {
			categorieID: 1,
			selectedType: null,
			customType: "",
			uploadedFiles: [],
			errorMessage: "",
			types: {},
		};
	},
	created() {
		this.fetchTypes();
	},
	methods: {
		checkUploadFile(type) {
			return ["image/jpeg", "image/png", "application/pdf"].includes(type);
		},
		handleFileUpload(event) {
			const files = Array.from(event.target.files);
			for (const file of files) {
				if (this.checkUploadFile(file.type)) {
					const uploadFile = {
						name: file.name,
						size: file.size,
						type: file.type,
						blob: file,
					};
					this.uploadedFiles.push(uploadFile);
					this.errorMessage = "";
				} else {
					this.errorMessage = "Seuls les fichiers JPEG, PNG et PDF sont autorisés.";
				}
			}
		},
		async fetchTypes() {
			try {
				const response = await fetch(process.env.VUE_APP_API_URL + "fichiers/types", { method: "GET", credentials: "include", });
				const data = await response.json();
				if (data.error) {
					window.location.href = "/login";
				} else {
					this.types = data;
				}
			} catch (error) {
				console.log("Une erreur est survenue lors de la requête.");
			}
		},
		deleteFile(file) {
			this.uploadedFiles = this.uploadedFiles.filter((f) => f !== file);
		},
		async confirmAction() {
			if ((this.selectedType === "autre" && !this.customType) || (this.selectedType === null && !this.customType)) {
				return (this.errorMessage = "Aucun type sélectionné.");
			}

			let typeToSend = this.selectedType;
			if (this.selectedType === "autre" || !this.selectedType) typeToSend = this.customType;

			let files = this.uploadedFiles.map((file) => ({ ...file, selectedType: typeToSend }));
			this.$emit("confirm1", files);
			this.closePopup();
		},
		cancelAction() {
			this.closePopup();
			this.$emit("cancel1");
		},
		closePopup() {
			this.selectedType = null;
			this.customType = "";
			this.uploadedFiles = [];
			this.errorMessage = "";
		},
	},
	computed: {
		filteredGroupedTypes() {
			const filteredCategories = {};
			for (const [categoryName, types] of Object.entries(this.types)) {
				let filteredTypes = [];

				if (Array.isArray(types)) {
					filteredTypes = types.filter((type) => type.categorieID === this.categorieID);
				} else if (typeof types === "object" && types !== null) {
					if (types.categorieID === this.categorieID) {
						filteredTypes = [types];
					}
				} else {
					console.warn(`Expected types to be an array or object for category ${categoryName}, but got`, types);
				}

				if (filteredTypes.length > 0) {
					filteredCategories[categoryName] = filteredTypes;
				}
			}
			return filteredCategories;
		},
		flattenedTypes() {
			let allTypes = [];
			for (const types of Object.values(this.filteredGroupedTypes)) {
				allTypes = allTypes.concat(types);
			}
			return allTypes;
		},
		hasOptions() {
			return Object.keys(this.filteredGroupedTypes).length > 0;
		},
		isCustomTypeSelected() {
			return this.selectedType === "autre";
		},
	},
};
</script>